import React, { useCallback, useEffect, useState } from "react";
import { Search } from "lucide-react";
import { qrtListTemplates } from "../../apis/qrtAdmin";
import { Pager, Spinner, StatusChip, fmtDateTime } from "./qrtUi";
import { ScopedPage } from "./QrtScopedPage";

const PAGE_SIZE = 25;
const STATUSES = ["", "APPROVED", "PENDING", "REJECTED", "PAUSED", "DISABLED", "approved", "rejected"];

const TemplatesTable = ({ userId }) => {
  const [data, setData] = useState({ rows: [], total: 0 });
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await qrtListTemplates({
        user_id: userId, limit: PAGE_SIZE, offset: page * PAGE_SIZE,
        ...(search ? { search } : {}),
        ...(status ? { status } : {}),
      });
      setData(res.data?.data || { rows: [], total: 0 });
    } catch (_) {}
    finally { setLoading(false); }
  }, [userId, search, status, page]);

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [load]);

  useEffect(() => { setPage(0); }, [userId]);

  return (
    <div className="qrt-card">
      <div className="qrt-card-head">
        <Search size={15} style={{ color: "var(--text-3)" }} />
        <input type="search" placeholder="Search template name…" value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(0); }}
          style={{ flex: 1, border: "none", outline: "none" }} />
        <select value={status} onChange={(e) => { setStatus(e.target.value); setPage(0); }}>
          {STATUSES.filter((s, i, a) => a.indexOf(s) === i).map((s) => (
            <option key={s} value={s}>{s || "All statuses"}</option>
          ))}
        </select>
      </div>
      {loading ? <Spinner /> : (
        <table className="qrt-table">
          <thead>
            <tr>
              <th>Template</th>
              <th>Category</th>
              <th>Language</th>
              <th>Status</th>
              <th>Quality</th>
              <th className="r">Created</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map((t) => (
              <tr key={t.id}>
                <td>
                  <div className="mono" style={{ fontWeight: 600 }}>{t.name}</div>
                  <div className="sub">#{t.id}</div>
                </td>
                <td className="mono">{t.category || "—"}</td>
                <td className="mono">{t.language || "—"}</td>
                <td><StatusChip value={t.status} /></td>
                <td className="mono sub">{t.quality_score || "—"}</td>
                <td className="r sub">{fmtDateTime(t.created_at)}</td>
              </tr>
            ))}
            {data.rows.length === 0 && (
              <tr><td className="empty" colSpan={6}>No templates for this user</td></tr>
            )}
          </tbody>
        </table>
      )}
      <Pager page={page} total={data.total} pageSize={PAGE_SIZE} onPage={setPage} />
    </div>
  );
};

const QrtTemplates = () => (
  <ScopedPage title="Templates" noun="templates">
    {(userId) => <TemplatesTable userId={userId} />}
  </ScopedPage>
);

export default QrtTemplates;
